import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFoDotDangKyPhamViActionTypes } from "../../action-types/thuc-don/IFoDotDangKyPhamViActionTypes";
import { IFoDotDangKyPhamViReducer } from "../../page-state-model/thuc-don/IFoDotDangKyPhamViReducer";

const iniState: IFoDotDangKyPhamViReducer = {
    status: ePageBaseStatus.is_not_initialization,
    foDotDangKyPhamVis: [],
    dotDangKyPhamVisByDot: [],
    dotDangKyPhamVisByTruong: []
}

export const foDotDangKyPhamViReducer = (state: IFoDotDangKyPhamViReducer = iniState, action: IFoDotDangKyPhamViActionTypes): IFoDotDangKyPhamViReducer => {
    switch (action.type) {
        case "DOT_DANG_KY_PHAM_VI_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOT_DANG_KY_PHAM_VI_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foDotDangKyPhamVis: action.payload
            }
        case "DOT_DANG_KY_PHAM_VI_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foDotDangKyPhamVis: []
            }
        case "DOT_DANG_KY_PHAM_VI_LOAD_BY_DOT_DANG_KY_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOT_DANG_KY_PHAM_VI_LOAD_BY_DOT_DANG_KY_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dotDangKyPhamVisByDot: action.payload
            }
        case "DOT_DANG_KY_PHAM_VI_LOAD_BY_DOT_DANG_KY_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dotDangKyPhamVisByDot: []
            }
        case "DOT_DANG_KY_PHAM_VI_LOAD_BY_TRUONG_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOT_DANG_KY_PHAM_VI_LOAD_BY_TRUONG_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dotDangKyPhamVisByTruong: action.payload
            }
        case "DOT_DANG_KY_PHAM_VI_LOAD_BY_TRUONG_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dotDangKyPhamVisByTruong: []
            }
        default:
            return state;
    }
}
